import { searchPathPublisherQuestions } from '@ms/yammer-web-support/dist/urls';

import { SearchResultType } from '../types';

export { searchPathPublisherQuestions };

export const searchLegacyPath = '/search/:type';
export const searchPath = '/search';

export enum SearchPathType {
  Campaigns = 'campaigns',
  Files = 'files',
  Groups = 'groups',
  Inbox = 'inbox',
  Threads = 'threads',
  Questions = 'questions',
  Topics = 'topics',
  Users = 'users',
}

export const searchQueryTextKey = 'search';
export const searchQueryTypeKey = 'type';
export const searchQueryGroupScopeKey = 'groupScope';
export const searchQueryStartDateKey = 'start';
export const searchQueryEndDateKey = 'end';
export const searchQueryNetworkIdKey = 'networkId';
export const searchQueryParticipantUserIdsKey = 'participantUserIds';
export const searchQueryThreadStarterSenderIdKey = 'threadStarterSenderId';
export const searchQueryPostTypeKey = 'postType';
export const searchQueryTypeInboxValue = 'inbox';

export const searchPathsBySearchResultType: Record<SearchResultType, string> = {
  [SearchResultType.Thread]: searchPath.replace(':type', SearchPathType.Threads),
  [SearchResultType.Group]: searchPath.replace(':type', SearchPathType.Groups),
  [SearchResultType.User]: searchPath.replace(':type', SearchPathType.Users),
  [SearchResultType.File]: searchPath.replace(':type', SearchPathType.Files),
  [SearchResultType.Inbox]: searchPath.replace(':type', SearchPathType.Inbox),
  [SearchResultType.Topic]: searchPath.replace(':type', SearchPathType.Topics),
  [SearchResultType.NetworkQuestion]: searchPath.replace(':type', SearchPathType.Questions),
  [SearchResultType.PublisherNetworkQuestion]: searchPathPublisherQuestions,
  [SearchResultType.Campaign]: searchPath.replace(':type', SearchPathType.Campaigns),
};
